export default __webpack_public_path__ + "static/media/plain-sticker-1.c8ae7489.png";